import { Model, createId } from "../../../../shared/models/model";

export class Column extends Model {
  get defaults() {
    return {
      id: createId(),
    };
  }
}
